import React from 'react';
import { Modal, Form, Input } from 'antd';
import { toast } from 'react-toastify';

import api from '@services/api';
import { SuperGroup } from '@services/types';

interface Props {
  superGroupToUpdate?: SuperGroup;
  setSuperGroups: (deviceTypes: SuperGroup[]) => void;
  setSuperGroupToUpdate?: React.Dispatch<React.SetStateAction<SuperGroup | undefined>>;
  visible: boolean;
  onClose: VoidFunction;
}

const CreateSuperGroupModal: React.FC<Props> = ({ setSuperGroups, superGroupToUpdate, visible, onClose }) => {
  const [form] = Form.useForm<SuperGroup>();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (superGroupToUpdate) {
        await api.administration.updateSuperGroup({ ...values, id: superGroupToUpdate.id });
        toast.success('Scope was updated successfully');
      } else {
        await api.administration.createSuperGroup(values);
        toast.success('Scope was created successfully');
      }
      const superGroups = await api.administration.getSuperGroups();
      setSuperGroups(superGroups);
      form.resetFields();
      onClose();
    } catch (error) {
      toast.error('Scope was not updated/created due to error');
      console.log('CreateSuperGroupModal ~ handleSubmit ~ error', error);
    }
  };

  return (
    <Modal
      visible={visible}
      title={superGroupToUpdate ? 'Update an scope' : 'Create a new scope'}
      okText={superGroupToUpdate ? 'Update' : 'Create'}
      cancelText="Cancel"
      onCancel={onClose}
      onOk={handleSubmit}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={
          superGroupToUpdate || {
            name: '',
          }
        }
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: 'Please input the name of Scope!',
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.memo(CreateSuperGroupModal);
